import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Dialog, DialogActions, DialogContent } from '@guildeducationinc/recess';
import { prepareForSave } from '@src/utilities/gqlHelper';
import { omit } from 'lodash';
import { COMMENTS, HtmlEditor, MessageType, Messages, SAVE_COMMENT, TrackableButton, useLocale, } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const EditCommentModal = ({ comment, isOpen, onClose, onSave, required, }) => {
    const { t } = useLocale();
    const [draft, setDraft] = useState(comment);
    const [saveComment] = useMutation(SAVE_COMMENT, {
        refetchQueries: [
            {
                query: COMMENTS,
                variables: {
                    spec: {
                        clientId: comment.clientId,
                        commentableType: comment.commentableType,
                        commentableId: comment.commentableId,
                        isInternal: comment.isInternal,
                    },
                },
            },
        ],
    });
    const [isSaving, setIsSaving] = useState(false);
    const [messages, setMessages] = useState([]);
    useEffect(() => {
        setDraft(comment);
    }, [comment]);
    const handleSave = async () => {
        setIsSaving(true);
        setMessages([]);
        try {
            if (required && !draft.message) {
                if (draft.isInternal) {
                    setMessages([{ value: t('Notes are required'), type: MessageType.ERROR }]);
                }
                else {
                    setMessages([{ value: t('Comment is required'), type: MessageType.ERROR }]);
                }
                setIsSaving(false);
                return;
            }
            const result = await saveComment({
                variables: {
                    input: omit(prepareForSave(draft), 'createdById', 'updatedById', 'createdBy', 'updatedBy'),
                },
            });
            if (result.errors) {
                setMessages(result.errors.map(e => ({ value: e.message, type: MessageType.ERROR })));
            }
            else if (result.data?.saveComment && onSave) {
                draft.id = result.data.saveComment.id;
                await onSave(draft);
            }
            onClose();
        }
        catch (e) {
            setMessages([{ value: t('Error saving comment'), type: MessageType.ERROR }]);
        }
        finally {
            setIsSaving(false);
        }
    };
    const handleMessageChange = (message) => {
        setDraft(prev => ({ ...prev, message }));
    };
    let title = draft.id ? t('Edit Comment') : t('Add Comment');
    if (draft.isInternal) {
        title = draft.id ? t('Edit Note') : t('Add Note');
    }
    return (_jsxs(Dialog, { title: title, isOpen: isOpen, onClose: onClose, fullScreen: true, children: [_jsxs(DialogContent, { children: [_jsx(Messages, { messages: messages }), _jsx("div", { className: 'margin--top_16', children: _jsx(HtmlEditor, { label: t('Comment'), hideLabel: true, value: draft.message || '', onChange: handleMessageChange, minimal: true }) })] }), _jsxs(DialogActions, { fullScreen: true, children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Cancel', tag: 'edit_comment_modal', variant: 'outlined', onClick: onClose, children: t('Cancel') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Submit', tag: 'edit_comment_modal', onClick: handleSave, disabled: isSaving, variant: 'contained', children: t('Submit') })] })] }));
};
